import { config } from '##/services/store/store';
import { sendErrorToTealium } from '##/components/Error';
import {
  TealiumErrorCode,
  TealiumErrorContext,
} from '##/services/analytics/Tealium/TealiumErrorTypes';
import { getDeviceInformation } from '##/utils/device';
import { sendApiRequest } from '../apirequest';
import { version as AppVersion } from '../../../../package.json';
import {
  AuthenticationResponse,
  ActivationResponse,
  RefreshToken,
  RefreshTokenResponse,
  NewUserResponse,
} from './types';

export const getActivationCode = async (): Promise<AuthenticationResponse> => {
  const { generateCode } = config.$get().app.authConfig;
  const {
    deviceId,
    ipAddress,
    platform,
    firmwareVersion,
  } = await getDeviceInformation();

  const authRequestBody = {
    appVersion: AppVersion,
    deviceIdentifier: deviceId,
    ipAddress: ipAddress.ip,
    machine: platform,
    platform: 'Foxtel',
    system: 'foxtel',
    systemVersion: firmwareVersion,
  };

  return sendApiRequest<AuthenticationResponse>(
    generateCode,
    'POST',
    {},
    authRequestBody,
  );
};

export const getActivationStatus = async (
  status: AuthenticationResponse,
): Promise<ActivationResponse> => {
  const { validateCode } = config.$get().app.authConfig;
  const { deviceId: deviceIdentifier } = await getDeviceInformation();

  return sendApiRequest<ActivationResponse>(
    validateCode,
    'POST',
    {},
    { ...status, deviceIdentifier },
  );
};

export const getRefreshToken = async (
  token: RefreshToken,
): Promise<RefreshTokenResponse> => {
  const { refreshToken } = config.$get().app.authConfig;
  const { deviceId: deviceIdentifier } = await getDeviceInformation();

  try {
    const refreshTokenResponse = await sendApiRequest<RefreshTokenResponse>(
      refreshToken,
      'POST',
      {},
      { ...token, deviceIdentifier },
    );
    return refreshTokenResponse;
  } catch (err) {
    sendErrorToTealium({
      errorCode: TealiumErrorCode.RefreshToken,
      errorContext: TealiumErrorContext.API,
      errorDetail: JSON.stringify(err),
      errorSource: refreshToken,
      errorMessage: '',
    });
    throw err;
  }
};

export const getUserInfoOnRefresh = (
  activationToken: string,
): Promise<NewUserResponse> => {
  const authHeader = { Authorization: `Bearer ${activationToken}` };
  const { fetchUserApiEndpoint } = config.$get().app.userEndpoints;
  return sendApiRequest<NewUserResponse>(
    fetchUserApiEndpoint,
    'GET',
    authHeader,
    {},
  );
};
